// @flow
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {FreeSelectionBottomButton, FreeSelectionBottomButtonLabel} from "./FreeSelectionBottomStyle";
import {strings, styles} from "../../../../../config";
import CurrentRequestOperations from "../../../../../Store/Ducks/CurrentRequest/operations";


const FreeSelectionBottom = props => {
    if (!props.isDest && !props.isOrigin) {
        return null;
    }
    let labelText, buttonColor, clickHandler;
    if (!props.inZone) {
        labelText = strings.set_ooz_button_text;
        buttonColor = styles.oozColor;
        clickHandler = undefined;
    } else if (props.isDest) {
        labelText = strings.set_dest_button_text;
        buttonColor = styles.secondaryColor;
        clickHandler = props.selectDest;
    } else {
        labelText = strings.set_origin_button_text;
        buttonColor = styles.primaryColor;
        clickHandler = props.selectOrigin;
    }

    return (
        <FreeSelectionBottomButton style={{backgroundColor: buttonColor}} onClick={clickHandler}>
            <FreeSelectionBottomButtonLabel>
                {labelText}
            </FreeSelectionBottomButtonLabel>
        </FreeSelectionBottomButton>
    );
};

const mapStateToProps = state => {
    return {};
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            selectOrigin: CurrentRequestOperations.freeSelectionOrigin,
            selectDest: CurrentRequestOperations.freeSelectionDest,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapActionsToProps)(FreeSelectionBottom);



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelectionBottom/FreeSelectionBottom.js